// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"5dae2eb7","99":"e09aaa36","134":"0442b138","301":"a071f78a","398":"eae3f38e","453":"fb64c48b","605":"58e34ae5","944":"80b7fc22","968":"dcdc47c4"}[chunkId] + ".chunk.js";
};